import React, {useState} from 'react'
import { Col, Button, Modal, Container, Row  } from 'react-bootstrap';
import { getItem } from '../../config/localStorage';
import TemplatelayoutOne from './displaytemplatelayout/TemplatelayoutOne';
import TemplatelayoutTwo from './displaytemplatelayout/TemplatelayoutTwo';
import './displaytemplatelayout/style/template.css';

function PreviewTemplate() {

    const defaultTempLayout = '1';
    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);
    const seletedTemp = getItem('choosenTemplateType') ?? defaultTempLayout;

    return (
        <>
            <Button className='my-previous-btn float-start btn btn-primary ms-3' type="submit" onClick={handleShow}>Preview</Button>

            <Modal
                dialogClassName="cust-large-modal-90w show-preview-temp"
                aria-labelledby="example-custom-modal-styling-title"
                backdrop='static'
                show={show} 
                onHide={handleClose}
            >
                <Modal.Header closeButton>
                    <Modal.Title id="example-custom-modal-styling-title">
                        Resume Preview layout
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body >
                    <Container>
                        <Row>
                            <Col md={12} className='template-overflow-scroll-resp'>
                                {
                                    seletedTemp === '1'  ? <TemplatelayoutOne /> : <TemplatelayoutTwo />
                                }
                            </Col>
                        </Row>
                    </Container>
                </Modal.Body>
            </Modal>
        </>
    )
}

export default PreviewTemplate
